
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line global-require
  module.exports = require('./dist/hotkeys.common.min.js');
} else {
  // eslint-disable-next-line global-require
  module.exports = require('./dist/hotkeys.common.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/hotkeys-js/index.js
// module id = 837
// module chunks = 1